// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__PxxIj","intro-gradient":"Footer_intro-gradient__p3JOf"};